import React from 'react';
import { Link, Navigate, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LogOut, Receipt } from 'lucide-react';
import { Button } from './Button';
import { Stepper } from './Stepper';
import { StatusMarker } from './StatusMarker';
import { usePlatform } from '../contexts/PlatformContext';
export function AppShell() {
  const {
    authenticated,
    user,
    goal,
    signOut,
    switchProfile
  } = usePlatform();
  const navigate = useNavigate();
  if (!user) return <Navigate to={authenticated ? '/choose-profile' : '/'} replace data-id="element-26" data-mp="1gbpz8q1u2shn" />;
  const initials = user.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();
  return <div className="min-h-screen w-full bg-[#0f1017]" data-id="element-27" data-mp="1bincb0rkahaf">
      <header className="sticky top-0 z-20 border-b border-white/10 bg-[#0f1017]/85 backdrop-blur" data-id="element-28" data-mp="1bhc6ywigx1h7">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-6 px-6 py-4" data-id="element-29" data-mp="1z7g2egli5ux4">
          <Link to="/profile" className="text-xl font-semibold tracking-tight" data-id="element-30" data-mp="23zpwm8tnhh57">nawat</Link>
          <Stepper data-id="element-31" data-mp="1rdwtggfvzvxa" />
          <div className="flex items-center gap-2" data-id="element-32" data-mp="1rdde97hmflmy">
            <NavLink to="/orders" className={({
            isActive
          }) => `flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm transition-colors ${isActive ? 'bg-white/10 text-foreground' : 'text-muted-foreground hover:text-foreground'}`} data-id="element-33" data-mp="1meah097vujpj">
              <Receipt className="size-4" data-id="element-34" data-mp="2a1s43rg7ctm6" />
              <span className="hidden sm:inline" data-id="element-35" data-mp="254ieaaowifxt">Orders</span>
            </NavLink>
            {goal && <span className="hidden sm:inline-flex" data-id="element-36" data-mp="2k22gj9uexx0a">
                <StatusMarker goal={goal} size="sm" data-id="element-37" data-mp="2jzg9dbbfpjil" />
              </span>}
            <button onClick={() => {
            switchProfile();
            navigate('/choose-profile');
          }} className="flex size-8 items-center justify-center rounded-full border border-[#9b8cf0]/50 font-mono text-xs text-[#c4baff] transition-colors hover:bg-[#9b8cf0]/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#9b8cf0]" title={`${user.name} · Switch profile`} aria-label={`Signed in as ${user.name}. Switch profile`} data-id="element-38" data-mp="2f2zcnsq65wtw">
              {initials}
            </button>
            <Button variant="ghost" size="icon-sm" aria-label="Sign out" onClick={() => {
            signOut();
            navigate('/');
          }} data-id="element-39" data-mp="1od4r3bxq7hiu">
              <LogOut className="size-4" data-id="element-40" data-mp="1xangesieki0j" />
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-10 md:py-14" data-id="element-41" data-mp="2262v1mo8ihy0">
        <Outlet data-id="element-42" data-mp="272bg1gp455d3" />
      </main>
    </div>;
}